import { filter } from 'rxjs/operators';
import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter, ComponentFactoryResolver, Injector, ChangeDetectorRef, Optional, Inject, LOCALE_ID } from '@angular/core';
import { MessageNotice } from '../message-notice';
import { MessagerService } from '@farris/ui-messager';
import { ProcessDesignerUIState } from '../../../app/process-designer.uistate';
import { ExprEditMode, ExpressionService, InjectedType, VarEntity} from '@gsp-svc/expression';
import { MessageReceiver } from '../message-receiver';
import { BsModalService } from '@farris/ui-modal';
import { ActivityListComponent } from '../../activity-list/activity-list.component';
import { HttpService } from '@ecp-caf/caf-common';
import { SysFarrisLookupComponent } from '@gsp-sys/sysmgr-ui';
import { PositionPerformerComponent } from '../../performer/views/position-performer/position-performer.component';
import { SmsMessageTemplateComponent } from '../../sms-message-template/sms-message-template.component';
import { SmsMessageTemplate } from '../../sms-message-template/sms-message-template';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../i18n/assets/lang.resource';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../i18n/pipe/wf-process-editor-locale.pipe';

@Component({
  selector: 'lib-message-notice-edit',
  templateUrl: './message-notice-edit.component.html',
  styleUrls: ['./message-notice-edit.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class MessageNoticeEditComponent implements OnInit {

  groupIcon2 = '<i class="f-icon f-icon-lookup"></i>';
  exprAble = false;
  @ViewChild('footer') footer: TemplateRef<any>;
  @ViewChild(SmsMessageTemplateComponent) SmsTemplate:SmsMessageTemplateComponent

  @Output() closeEmitter = new EventEmitter<any>();
  @Output() submitEmitter = new EventEmitter<MessageNotice>();
  @ViewChild(SysFarrisLookupComponent) userHelp: SysFarrisLookupComponent;

  private _location: 'activity' | 'process' | 'messageActivity' = 'activity';
  @Input()
  set location(l: 'activity' | 'process' | 'messageActivity') {
    this._location = l;
    if (this.location !== 'activity') {
      this.processParticipantTypes = [
        { value: 'procInstCreator', text: this.localePipe.transform('component.messageNoticeEdit.procInstCreator') },
        { value: 'activityExecutorParticipant', text:  this.localePipe.transform('component.messageNoticeEdit.activityExecutorParticipant') }];
    }
  }

  get location() {
    return this._location;
  }

  messageNotice = new MessageNotice();
  @Input()
  set value(m: MessageNotice) {
    // 深拷贝处理messageNotice 2022-12-1
    const jsonMessageNotice = JSON.stringify(Object.assign({}, m));
    this.messageNotice = JSON.parse(jsonMessageNotice);
    this.exprAble = this.messageNotice.subject.charAt(0) === '{';
    if (this.hasSmsMessage(this.messageNotice.sendType)) {
      this.hasSmsTemplate = true;
      if (!this.messageNotice.smsMessageTemplate) {
        this.messageNotice.smsMessageTemplate = new SmsMessageTemplate();
      }
    }
  }

  get value() {
    return this.messageNotice;
  }
  typeGroup = this.uistate.messageChannels.map(m => ({ value: m.code, name: m.name }));

  receiverVariables = [
    { value: 'workItemParticipant', name: this.localePipe.transform('component.messageNoticeEdit.workItemParticipant') }
  ];

  variableOrgTypes = [
    { name: this.localePipe.transform('component.messageNoticeEdit.sys'), value: 'Sys' },
    { name: this.localePipe.transform('component.messageNoticeEdit.administrative_organization'), value: 'Administrative_organization' }
  ];
  sendTimes = [];
  receiverVari: string;
  bindingData: { id?, name?} = {};
  index;
  receiverTypes = [
    { value: 'processParticipant', text: this.localePipe.transform('component.MessageNotice.processParticipant') },
    { value: 'variableParticipant', text: this.localePipe.transform('component.MessageNotice.variableParticipant') },
    { value: 'userParticipant', text: this.localePipe.transform('component.MessageNotice.userParticipant') },
    { value: 'positionParticipant', text: this.localePipe.transform('component.MessageNotice.positionParticipant') },
  ];
  processParticipantTypes = [
    { value: 'procInstCreator', text: this.localePipe.transform('component.MessageNotice.procInstCreator') },
    { value: 'workItemParticipant', text: this.localePipe.transform('component.MessageNotice.workItemParticipant') },
    { value: 'activityExecutorParticipant', text: this.localePipe.transform('component.MessageNotice.activityExecutorParticipant') },
  ];
  userTypeButtonNeedShow = false; // 用户类型单选按钮是否需要显示
  hasAdminOrg;
  hasSmsTemplate = false;

  constructor(
    private message: MessagerService,
    private uistate: ProcessDesignerUIState,
    private expr: ExpressionService,
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private modalService: BsModalService,
    private designerUIState: ProcessDesignerUIState,
    private http: HttpService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
  }

  ngOnInit() {
    if (this.location === 'activity') {
      this.sendTimes = this.activitySendTime;
      if (this.messageNotice.sendTime === this.activitySendTime[0].value || this.messageNotice.sendTime === this.activitySendTime[1].value) {
        this.receiverTypes = [
          { value: 'processParticipant', text: this.localePipe.transform('component.messageNoticeEdit.processParticipant') }
        ];
        this.processParticipantTypes = [
          { value: 'workItemParticipant', text: this.localePipe.transform('component.messageNoticeEdit.workItemReceiveParticipant') }
        ];
      } else {
        this.receiverTypes = [
          { value: 'processParticipant', text: this.localePipe.transform('component.messageNoticeEdit.processParticipant') },
          { value: 'variableParticipant', text: this.localePipe.transform('component.messageNoticeEdit.variableParticipant') },
          { value: 'userParticipant', text: this.localePipe.transform('component.messageNoticeEdit.userParticipant') },
          { value: 'positionParticipant', text: this.localePipe.transform('component.messageNoticeEdit.positionParticipant') },
        ];
        this.processParticipantTypes = [
          { value: 'procInstCreator', text: this.localePipe.transform('component.messageNoticeEdit.procInstCreator') },
          { value: 'activityExecutorParticipant', text: this.localePipe.transform('component.messageNoticeEdit.activityExecutorParticipant') }
        ];
      }
    } else {
      this.sendTimes = this.processSendTime;
    }

    const url = '/api/runtime/wf/v1.0/reportingOrgType/hasAdminOrg';
    this.http.get(url).subscribe((data: any) => {
      this.hasAdminOrg = data;
      // inSuite场景，变量参与者场景下显示用户类型
      if (this.designerUIState.scene === 'inSuite') {
        this.userTypeButtonNeedShow = true;
      } else {
        this.userTypeButtonNeedShow = data;
      }
      if (!this.userTypeButtonNeedShow) {
        this.variableOrgTypes = [{ name: this.localePipe.transform('component.messageNoticeEdit.sys'), value: 'Sys' }];
      }
    });
  }

  clickOK() {
    if (this.SmsTemplate) {
      this.SmsTemplate.endGridEdit();
    }
    this.setReceiver();
    if (this.hasSmsTemplate) {
      this.messageNotice.smsMessageTemplate = this.SmsTemplate.smsMessageTemplate;
      if (this.messageNotice.smsMessageTemplate.smsMessageVariables && this.messageNotice.smsMessageTemplate.smsMessageVariables.length > 0) {
        this.messageNotice.smsMessageTemplate.smsMessageVariables = this.messageNotice.smsMessageTemplate.smsMessageVariables.filter(variable => variable.code);
      }
    } else {
      this.messageNotice.smsMessageTemplate = null;
    }
    if (this.validator()) {
      this.submitEmitter.emit(this.messageNotice);
    }
  }
  clickCancel() {
    this.closeEmitter.emit();
  }

  sendTimeChange(data: any) {
    if (data.data.value === this.activitySendTime[0].value || data.data.value === this.activitySendTime[1].value) {
      const messageReceiver = new MessageReceiver();
      messageReceiver.type = 'processParticipant';
      messageReceiver.processParticipant = 'workItemParticipant';
      this.messageNotice.receivers = [messageReceiver];
      this.receiverTypes = [
        { value: 'processParticipant', text: this.localePipe.transform('component.messageNoticeEdit.processParticipant') }
      ];
      this.processParticipantTypes = [
        { value: 'workItemParticipant', text: this.localePipe.transform('component.messageNoticeEdit.workItemParticipant') }
      ];
    } else {
      for (const r of this.messageNotice.receivers) {
        if (r.type === 'processParticipant' && r.processParticipant === 'workItemParticipant') {
          r.processParticipant = 'procInstCreator';
        }
      }
      this.receiverTypes = [
        { value: 'processParticipant', text: this.localePipe.transform('component.messageNoticeEdit.processParticipant') },
        { value: 'variableParticipant', text: this.localePipe.transform('component.messageNoticeEdit.variableParticipant') },
        { value: 'userParticipant', text: this.localePipe.transform('component.messageNoticeEdit.userParticipant') },
        { value: 'positionParticipant', text: this.localePipe.transform('component.messageNoticeEdit.positionParticipant') },
      ];
      this.processParticipantTypes = [
        { value: 'procInstCreator', text: this.localePipe.transform('component.messageNoticeEdit.procInstCreator') },
        { value: 'activityExecutorParticipant', text: this.localePipe.transform('component.messageNoticeEdit.activityExecutorParticipant') }
      ];
    }
  }

  sendTypeChange(sendType: string) {
    if (this.hasSmsMessage(sendType)) {
      this.hasSmsTemplate = true;
      if (!this.messageNotice.smsMessageTemplate) {
        this.messageNotice.smsMessageTemplate = new SmsMessageTemplate();
      }
    } else {
      this.hasSmsTemplate = false;
      this.messageNotice.smsMessageTemplate = null;
    }
  }
  private hasSmsMessage(sendType: string) {
    if (sendType) {
      const sendTypeList = sendType.split(',');
      let messageChannel = sendTypeList.find(val => this.uistate.messageChannels.find(channel => channel.code == val && channel.channelType == 'Sms'));
      if (messageChannel) {
        return true;
      } else {
        return false;
      }
    } else {
      return false
    }
  }

  usersSelect(data: any[]) {
    this.messageNotice.receivers[this.index].userIds = '';
    this.messageNotice.receivers[this.index].userNames = '';
    if (data && data.length > 0) {
      let userIds = '';
      for (const d of data) {
        userIds += d.id + ',';
      }
      if (userIds) {
        this.messageNotice.receivers[this.index].userIds = userIds.substring(0, userIds.length - 1);
      }
      let userNames = '';
      for (const d of data) {
        userNames += d.name + ',';
      }
      if (userNames) {
        this.messageNotice.receivers[this.index].userNames = userNames.substring(0, userNames.length - 1);
      }
    }
  }

  clearUsers(index: any) {
    this.messageNotice.receivers[index].userIds = '';
    this.messageNotice.receivers[index].userNames = '';
  }

  clearPosition(index: any) {
    this.messageNotice.receivers[index].positionId = '';
    this.messageNotice.receivers[index].positionName = '';
    this.messageNotice.receivers[index].positionType = '';
    this.messageNotice.receivers[index].orgId = '';
    this.messageNotice.receivers[index].orgType = '';
  }

  clearActivityExecutor(index: any) {
    this.messageNotice.receivers[index].activityDefId = '';
    this.messageNotice.receivers[index].activityDefName = '';
  }

  clearVariableParticipant(index: any) {
    this.messageNotice.receivers[index].variableParticipant = '';
    this.messageNotice.receivers[index].variableName = '';
  }

  changeValue(data) {
  }
  clear() {
    this.bindingData = {};
  }
  private setReceiver() {
  }

  private validator(): boolean {
    if (!this.messageNotice.sendType) {
      this.message.info(this.localePipe.transform('component.messageNoticeEdit.sendType'));
      return false;
    }
    //去除消息模板编号校验
    // if (this.hasSmsTemplate) {
    //   if (!this.messageNotice.smsMessageTemplate) {
    //     this.message.info(this.localePipe.transform('component.messageNoticeEdit.smsMessageTemplate'));
    //     return;
    //   }
    //   if (!this.messageNotice.smsMessageTemplate.code) {
    //     this.message.info(this.localePipe.transform('component.messageNoticeEdit.smsMessageTemplateCode'));
    //     return;
    //   }
    // }
    if (this.location !== 'messageActivity' && !this.messageNotice.sendTime) {
      this.message.info(this.localePipe.transform('component.messageNoticeEdit.sendTime'));
      return false;
    }
    if (!this.messageNotice.subject) {
      this.message.info(this.localePipe.transform('component.messageNoticeEdit.subject'));
      return false;
    }
    if (!this.messageNotice.content) {
      this.message.info(this.localePipe.transform('component.messageNoticeEdit.content'));
      return false;
    }
    this.messageNotice.receivers = this.messageNotice.receivers.filter(r => r.type);
    if (!this.messageNotice.receivers || this.messageNotice.receivers.length === 0) {
      this.message.info(this.localePipe.transform('component.messageNoticeEdit.receivers'));
      return false;
    } else {
      for (const r of this.messageNotice.receivers) {
        switch (r.type) {
          case 'processParticipant':
            if (!r.processParticipant) {
              this.message.info(this.localePipe.transform('component.messageNoticeEdit.processParticipantNotNull'));
              return false;
            } else if (r.processParticipant === 'activityExecutorParticipant' && !r.activityDefId) {
              this.message.info(this.localePipe.transform('component.messageNoticeEdit.activityDefIdNotNull'));
              return false;
            }
            break;
          case 'variableParticipant':
            if (!r.variableParticipant) {
              this.message.info(this.localePipe.transform('component.messageNoticeEdit.variableParticipantNotNull'));
              return false;
            }
            if (!r.orgType) {
              this.message.info(this.localePipe.transform('component.messageNoticeEdit.orgType'));
              return false;
            }
            break;
          case 'userParticipant':
            if (!r.userIds) {
              this.message.info(this.localePipe.transform('component.messageNoticeEdit.userIds'));
              return false;
            }
            break;
          case 'positionParticipant':
            if (!r.positionId) {
              this.message.info(this.localePipe.transform('component.messageNoticeEdit.positionId'));
              return false;
            }
            break;
        }
      }
    }
    return true;
  }

  disableAdd = () => {
    if ((this.messageNotice.sendTime === 'WORKITEM_CREATED' || this.messageNotice.sendTime === 'WORKITEM_ABORTED') && this.messageNotice.receivers.filter(r => r.type).length > 0) {
      return true;
    } else {
      return false;
    }
  }

  addReceiver() {
    if (this.disableAdd()) {
      return;
    }
    const receivers = this.messageNotice.receivers.filter(r => r.type);
    if (receivers && receivers.length > 0) {
      const userParticipant = new MessageReceiver();
      userParticipant.type = 'userParticipant';
      this.messageNotice.receivers = this.messageNotice.receivers.concat([userParticipant]);
    } else {
      if (this.location !== 'activity') {
        const procInstCreator = new MessageReceiver();
        procInstCreator.type = 'processParticipant';
        procInstCreator.processParticipant = 'procInstCreator';
        this.messageNotice.receivers = this.messageNotice.receivers.concat([procInstCreator]);
      } else {
        const workItemParticipant = new MessageReceiver();
        workItemParticipant.type = 'processParticipant';
        workItemParticipant.processParticipant = 'workItemParticipant';
        this.messageNotice.receivers = this.messageNotice.receivers.concat([workItemParticipant]);
      }
    }
  }
  selectActivityExecutorParticipant(activityDefId: string, index: any) {
    let dialog: any;
    const compFactory = this.resolver.resolveComponentFactory(ActivityListComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.submitEmitter.subscribe((re: any[]) => {
      const acticity = re.shift();
      this.messageNotice.receivers[index].activityDefId = acticity.id;
      this.messageNotice.receivers[index].activityDefName = acticity.data.Name;
      if (re && re.length > 0) {
        for (const a of re) {
          const receiver = new MessageReceiver();
          receiver.type = 'processParticipant';
          receiver.processParticipant = 'activityExecutorParticipant';
          receiver.activityDefId = a.id;
          receiver.activityDefName = a.data.Name;
          this.messageNotice.receivers = this.messageNotice.receivers.concat([receiver]);
        }
      }
      dialog.close();
    });
    compRef.instance.closeEmitter.subscribe(r => {
      dialog.close();
    });
    const modalConfig = {
      title: this.localePipe.transform('component.messageNoticeEdit.activityList'),
      width: 490,
      height: 490,
      showButtons: true,
      buttons: compRef.instance.buttonRef
    };
    dialog = this.modalService.show(compRef, modalConfig);
  }
  selectVariableParticipant(variableParticipant: string, index: any) {
    const context = new Array<VarEntity>();
    // if(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage')) {
    //   context.push(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage'));
    // }
    // this.expr.clearContext();
    this.expr.setEditPattern(ExprEditMode.Advanced);
    if (this.designerUIState.schemas.length > 0) {
      for (const schema of this.designerUIState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerUIState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    if (this.designerUIState.participantContext.length > 0) {
      for (const variable of this.designerUIState.participantContext) {
        context.push(variable);
      }
    }
    if (this.designerUIState.processVariableContext.length > 0) {
      for (const variable of this.designerUIState.processVariableContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.designerUIState.subActivityContext.length > 0) {
      for (const variable of this.designerUIState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    if (variableParticipant) {
      this.expr.addExpressionText(variableParticipant);
    } else {
      this.expr.addExpressionText('');
    }
    this.expr.buildExpression().then((expressioninfo: string) => {
      this.messageNotice.receivers[index].variableParticipant = expressioninfo;
      this.messageNotice.receivers[index].variableName = this.variableParticipantName(expressioninfo);
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }
  selectUserParticipant(receiver: MessageReceiver, index: any) {
    this.index = index;
    this.bindingData = {};
    if (receiver.userIds && receiver.userIds.length > 0) {
      this.bindingData.id = receiver.userIds;
      this.bindingData.name = receiver.userNames;
    }
    setTimeout(() => {
      this.userHelp.showHelp();
    }, 0);
  }

  selectPositionParticipant(receiver: MessageReceiver, index: any) {
    let dialog: any;
    const compFactory = this.resolver.resolveComponentFactory(PositionPerformerComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.showCondition = false;
    compRef.instance.position.performerId = this.messageNotice.receivers[index].positionId;
    compRef.instance.position.performerName = this.messageNotice.receivers[index].positionName;
    compRef.instance.position.positionType = this.messageNotice.receivers[index].positionType;
    compRef.instance.position.orgId = this.messageNotice.receivers[index].orgId;
    compRef.instance.position.orgType = this.messageNotice.receivers[index].orgType;
    if (compRef.instance.position.positionType === '0') {
      compRef.instance.newFilter = { positionType: '0' };
    } else {
      compRef.instance.newFilter = { positionType: '1' };
    }
    compRef.instance.submitEmitter.subscribe((re: any) => {
      if (re.performerId) {
        this.messageNotice.receivers[index].positionId = re.performerId;
        this.messageNotice.receivers[index].positionName = re.performerName;
        this.messageNotice.receivers[index].positionType = re.positionType;
        this.messageNotice.receivers[index].orgId = re.orgId;
        this.messageNotice.receivers[index].orgType = re.orgType;
      }
      dialog.close();
    });
    compRef.instance.closeEmitter.subscribe(r => {
      dialog.close();
    });
    const modalConfig = {
      title: this.localePipe.transform('component.messageNoticeEdit.position'),
      width: 700,
      height: 400,
      showButtons: true,
      buttons: compRef.instance.buttonRef
    };
    dialog = this.modalService.show(compRef, modalConfig);
  }

  titleExpr(data: any){
    this.showTitleHelp(data);
  }
  contentExpr(data: any){
    this.showContentHelp(data);
  }

  showContentHelp(data: string){
    const context = this.showExpr();
    if (this.messageNotice.content && this.messageNotice.content.length > 0) {
      this.expr.addExpressionText(this.messageNotice.content);
    } else {
      this.expr.addExpressionText('');
    }
    this.expr.buildExpression().then((expressionInfo: string) => {
      this.messageNotice.content = expressionInfo;
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

  showTitleHelp(data: string) {
    if(this.messageNotice.subject && this.messageNotice.subject.charAt(0) !== '{'){
      this.messageNotice.subject = '';
    }
    const context = this.showExpr();
    if (this.messageNotice.subject && this.messageNotice.subject.length > 0) {
      this.expr.addExpressionText(this.messageNotice.subject);
    } else {
      this.expr.addExpressionText('');
    }
    this.expr.buildExpression().then((expressionInfo: string) => {
      this.messageNotice.subject = expressionInfo;
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }
  showExpr(){
    const context = new Array<VarEntity>();
    // if(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage')) {
    //   context.push(this.expr.exprEntity.contextEntities.find(x => x.key === 'CurrentLanguage'));
    // }
    // this.expr.clearContext();
    if (this.uistate.schemas.length > 0) {
      for (const schema of this.uistate.schemas) {
        // this.expr.addCommonObject(co);
        this.expr.addSchema('Schema', schema);
      }
      if (this.uistate.schemas[0].entityTypes && this.uistate.schemas[0].entityTypes.length > 0) {
        const entityType = this.uistate.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    if (this.uistate.procInstContext.length > 0) {
      for (const variable of this.uistate.procInstContext) {
        context.push(variable);
        // this.expr.addContext(variable);
      }
    }
    if (this.uistate.subActivityContext.length > 0) {
      for (const variable of this.uistate.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
        // this.expr.addContext(variable);
      }
    }
    if (this.uistate.processVariableContext.length > 0) {
      for (const variable of this.uistate.processVariableContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
        // this.expr.addContext(variable);
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }

    return context;
  }
  tranExpr(){
    this.messageNotice.subject = '';
  }

  private variableParticipantName(expr: string): string {
    for (const c of this.designerUIState.participantContext) {
      if (expr.indexOf(c.key) > -1) {
        return c.name;
      }
    }
    for (const c of this.designerUIState.processVariableContext) {
      if (expr.indexOf(c.key) > -1) {
        return c.name;
      }
    }
    return JSON.parse(expr).expr;
  }
  // 由于需要实现国际化，此处定义不能提取；
  processSendTime = [
    { value: 'PROCESSINSTANCE_COMPLETED', text: this.localePipe.transform('component.MessageNotice.procComplete') },
    { value: 'PROCESSINSTANCE_ABORTED', text: this.localePipe.transform('component.MessageNotice.procAborted') },
    { value: 'PROCESSINSTANCE_ROLLBACK', text: this.localePipe.transform('component.MessageNotice.procRollBack') }
  ];
  ReceiverType = [
    { value: 'processParticipant', text: this.localePipe.transform('component.MessageNotice.processParticipant') },
    { value: 'variableParticipant', text: this.localePipe.transform('component.MessageNotice.variableParticipant') },
    { value: 'userParticipant', text: this.localePipe.transform('component.MessageNotice.userParticipant') },
    { value: 'positionParticipant', text: this.localePipe.transform('component.MessageNotice.positionParticipant') },
  ];
  activitySendTime = [
    { value: 'WORKITEM_CREATED', text: this.localePipe.transform('component.MessageNotice.workCreated') },
    { value: 'WORKITEM_ABORTED', text: this.localePipe.transform('component.MessageNotice.workAborted') },
    { value: 'ACTIVITY_COMPLETED', text: this.localePipe.transform('component.MessageNotice.actComplete') },
    { value: 'ACTIVITY_ABORTED', text: this.localePipe.transform('component.MessageNotice.actAborted') },
  ];
}
